import React from "react";
import { decreaseItem } from "../../Redux/Actions";
import { increaseItem } from "../../Redux/Actions";
import { useSelector, useDispatch } from "react-redux";
import "./ItemsNum.css";

function ItemsNum() {
  const counter = useSelector((state) => state.counterItems);
  const dispatch = useDispatch();

  const handleIncrease = () => {
    dispatch(increaseItem());
  };

  const handleDecrease = () => {
    if (counter == 1) {
      return null;
    } else {
      dispatch(decreaseItem());
    }
  };

  return (
    <div className="counter">
      <button onClick={handleIncrease}> + </button>
      <p>{counter}</p>
      <button onClick={handleDecrease}> - </button>
    </div>
  );
}

export default ItemsNum;
